module.exports = __webpack_public_path__ + "static/media/3_1.e8ae8b32.png";